import styled from 'styled-components'

import Dropdown from '~/shared/components/dropdown/Dropdown'
import Tag from '~/shared/components/tags/Tag'
import theme from '~/shared/styles/theme'

function TestPage() {
  return (
    <Wrapper>
      <Tag $size="sm" $variant="gray">
        태그 텍스트
      </Tag>
      <Tag $size="sm" $variant="mint">
        태그 텍스트
      </Tag>
      <Tag $size="sm" $variant="pink">
        태그 텍스트
      </Tag>
      <Tag $size="md" $variant="gray">
        태그 텍스트
      </Tag>
      <Tag $size="md" $variant="mint">
        태그 텍스트
      </Tag>
      <Tag $size="md" $variant="pink">
        태그 텍스트
      </Tag>
      <Dropdown
        options={[
          { value: '옵션 1', label: '옵션 1' },
          { value: '옵션 2', label: '옵션 2' },
          { value: '옵션 3', label: '옵션 3' },
        ]}
      />
    </Wrapper>
  )
}

export default TestPage

const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 20px;

  width: 100vw;
  min-height: calc(100vh - ${theme.size.headerHeight}px);

  font-family: NanumSquareNeo-Regular, sans-serif;
  font-size: 50px;
`
